import REDUX_ACTION from 'modules/redux/constants/action'

/**
 * Updates the `value` at the given `payload.path`.
 * @param {Object} params
 *        {Object} params.type
 *        {Object} params.payload
 *        {string} [params.payload.path]
 *        {string} [params.payload.paths]
 *        {string} [params.payload.updates]
 *        {string} [params.payload.key]
 *        {string} [params.payload.value]
 *        {boolean} [params.payload.isLocal]
 */
function updateReduxAction (params) {
  return {
    type: params.type,
    reduxType: REDUX_ACTION.UPDATE,
    payload: params.payload
  }
}

export default updateReduxAction
